import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.min.css';
import './assets/css/custom.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

if (process.env.REACT_APP_THEME === 'WORKSPACEGEEK') {
  require('./assets/css/custom-workspacegeek.css');
}

if (process.env.REACT_APP_THEME === '640TECH') {
  require('./assets/css/custom-640tech.css');
}

ReactDOM.render(
  //<React.StrictMode>
  <App />,
  //</React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
